var _circle, _circle2, _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 74.5,
    cy: 74.5,
    r: 74.5,
    fill: "#359943"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 74.5001,
    cy: 74.5,
    r: 58.752,
    fill: "#359943"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.4961,
    y: 30.2845,
    width: 87.2222,
    height: 87.2244,
    rx: 43.6111,
    fill: "#359943"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.0039 72.3128V65.5774C91.0039 59.9646 88.7588 57.7195 83.146 57.7195H76.4107C70.7979 57.7195 68.5527 59.9646 68.5527 65.5774V67.3414H73.5241C79.1369 67.3414 81.382 69.5866 81.382 75.1994V80.1707H83.146C88.7588 80.1707 91.0039 77.9256 91.0039 72.3128Z",
    stroke: "white",
    strokeWidth: 2.40549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3824 81.9347V75.1994C81.3824 69.5866 79.1372 67.3414 73.5244 67.3414H66.7891C61.1763 67.3414 58.9312 69.5866 58.9312 75.1994V81.9347C58.9312 87.5475 61.1763 89.7926 66.7891 89.7926H73.5244C79.1372 89.7926 81.3824 87.5475 81.3824 81.9347Z",
    stroke: "white",
    strokeWidth: 2.40549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4741 78.5672L68.6013 81.6943L74.8395 75.4401",
    stroke: "white",
    strokeWidth: 2.40549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.e4739b6337ae355a182e8d4566f18421.svg";
export { ForwardRef as ReactComponent };